import Holidaycheck from 'static-components/src/vue/holiday-check/holiday-check.vue';
import Vue from 'vue';
var initializeHolidaycheck = function () {
    var mountEl = document.querySelector('c-holiday-check');
    if (mountEl) {
        new Vue({
            render: function (h) { return h(Holidaycheck); },
        }).$mount('c-holiday-check');
    }
};
export default initializeHolidaycheck;
